import { Trans } from 'react-i18next';

import { IdentityDocumentType } from '@dreryk/egabinet-patient-published-language-api';

import { useTranslate } from '@dreryk/react-common';

import { entitlementStatementsTranslationKeys } from '../../../translations';

import { getDocumentTypeTranslation } from './IdentityDocumentText';

type RepresentativeIdentityDocumentProps = {
   readonly documentType: string;
   readonly documentValue: string;
};

export const RepresentativeIdentityDocument = ({
   documentType,
   documentValue,
}: RepresentativeIdentityDocumentProps): JSX.Element => {
   const translate = useTranslate();
   const translatedDocumentType = translate(getDocumentTypeTranslation(documentType as IdentityDocumentType));
   return (
      <Trans
         i18nKey={entitlementStatementsTranslationKeys.representativeIdentityDocument}
         values={{
            documentType: translatedDocumentType,
            documentValue: documentValue,
         }}
      />
   );
};
